// Notification utility to replace alert() calls
export interface NotificationOptions {
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

// Global notification callback - this will be set by the app
let notificationCallback: ((options: NotificationOptions) => void) | null = null;

export const setNotificationCallback = (callback: (options: NotificationOptions) => void) => {
  notificationCallback = callback;
};

export const showNotification = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration: number = 3000) => {
  if (notificationCallback) {
    notificationCallback({ message, type, duration });
  } else {
    // Fallback to console if no callback is set
    console.log(`[${type.toUpperCase()}] ${message}`);
  }
};

// Convenience functions
export const showSuccess = (message: string, duration?: number) => {
  showNotification(message, 'success', duration);
};

export const showError = (message: string, duration?: number) => {
  showNotification(message, 'error', duration);
};

export const showWarning = (message: string, duration?: number) => {
  showNotification(message, 'warning', duration);
};

export const showInfo = (message: string, duration?: number) => {
  showNotification(message, 'info', duration);
};

// Replace alert function
export const alert = (message: string) => {
  showInfo(message);
}; 